import { countriesList, ICountry } from './countries';

export const PHONE_PREFIX = '+';

export const findCountryByValue = (value: string | undefined) => {
  if (value) {
    for (let i = 1; i <= 4; i++) {
      const searchValue = value.substring(1, i);
      const res = countriesList.find((el: ICountry) => el.code === searchValue);
      if (res) {
        return res;
      }
    }
  }
};

export const getDefaultPhone = (value: string) => {
  const countryCode: string | undefined = findCountryByValue(value)?.code;
  return countryCode ? value.replace(`${PHONE_PREFIX}${countryCode}`, '') : '';
};

export const getMask = (inputValue?: string, country?: ICountry) => {
  const { mask } = country || {};
  if (mask && inputValue) {
    if (typeof mask === 'string') return mask;

    if (Array.isArray(mask)) {
      const maskIndex = mask.findIndex(({ rule }) => (rule ? inputValue.match(rule) : null)) || 0;
      return mask[maskIndex].value;
    }
  }
};
